/**
 * Per-device memory of the sign-in code (SOC 2).
 *
 * After a verified code the server returns a random `device_token`. This
 * browser keeps it per account and sends it with the password, so only this
 * browser skips the code for a week. Another device still has to enter one.
 */

const keyFor = (email: string) => `trustedDevice:${email.trim().toLowerCase()}`;

export const getDeviceToken = (email: string): string | undefined => {
  try {
    return localStorage.getItem(keyFor(email)) || undefined;
  } catch {
    return undefined;
  }
};

export const saveDeviceToken = (email: string, token?: string | null) => {
  if (!token) return;
  try {
    localStorage.setItem(keyFor(email), token);
  } catch {
    // Private mode or storage blocked: the code is simply asked again.
  }
};
